/**
 * @generated SignedSource<<973febe6580798b0f6c59205b2ec6e24>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RootPageQuery$variables = Record<PropertyKey, never>;
export type RootPageQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"StatsigProvider_query">;
};
export type RootPageQuery = {
  response: RootPageQuery$data;
  variables: RootPageQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RootPageQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "StatsigProvider_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "RootPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StatsigInitializeResponse",
        "kind": "LinkedField",
        "name": "statsigInitializeResponse",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StatsigCustomID",
            "kind": "LinkedField",
            "name": "customIDs",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "initialValues",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "privateAttributes",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e54f965386f1c3a7c96aff04c3e7b682",
    "id": null,
    "metadata": {},
    "name": "RootPageQuery",
    "operationKind": "query",
    "text": "query RootPageQuery {\n  ...StatsigProvider_query\n}\n\nfragment StatsigProvider_query on Query {\n  statsigInitializeResponse {\n    userID\n    customIDs {\n      key\n      value\n    }\n    initialValues\n    privateAttributes\n  }\n}\n"
  }
};

(node as any).hash = "0b2207ca406bcf0ae3beed72a92fed58";

export default node;
